import FindAgreementNumberScreen from '../screens/FindAgreementNumber'
import { NextPage } from 'next'

export const FindAgreementNumber: NextPage = () => {

  return (
    <>
      <FindAgreementNumberScreen />
    </>
  )
}
